
import io, { type Socket } from 'socket.io-client'

import Debug from 'debug'
const debug = Debug('pandore:lib:socket')

type EventListener = (...args:any[])=> void

const CHANNEL_NAME = '/backoffice'
const DEFAULT_OPTIONS = {
	reconnection: true,
	reconnectionAttempts: Infinity,
	timeout: 1000,
	transports: ['websocket'],
}

let _socket:Socket

export default {
	connect(query:any) {
		return new Promise((resolve)=> {
			debug('Connecting socket to channel:',CHANNEL_NAME)
			const options = {
				...DEFAULT_OPTIONS,
				query,
			}
			debug('Using options:',options)

			_socket = io(CHANNEL_NAME,options)

			_socket.on('connect', ()=> {
				debug('Socket connected!', _socket)
			})

			_socket.once('welcome', (data:any)=> {
				debug('Welcome received:',data)
				resolve(data)
			})
		})
	},

	getSocket() {
		return _socket
	},

	emit(event:string, ...args:any[]) {
		debug('Emitting:',event,...args)
		return new Promise((resolve,reject)=> {
			_socket.emit(event, ...args, (err:string, result:any)=> {
				if (err)
					reject(err)
				else
					resolve(result)
			})
		})
	},

	on(event:string, fn:EventListener) {
		_socket.on(event, fn)
	},

	off(event:string, fn:EventListener) {
		_socket.off(event, fn)
	},

	once(event:string, fn:EventListener) {
		_socket.once(event, fn)
	},

	hasListeners(event:string) {
		_socket.hasListeners(event)
	},
}
